import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim()
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()

export const isCloudConfigured = Boolean(
  supabaseUrl &&
    supabaseAnonKey &&
    !supabaseUrl.includes('YOUR_PROJECT') &&
    !supabaseAnonKey.includes('YOUR_SUPABASE'),
)

export const supabase: SupabaseClient | null = isCloudConfigured
  ? createClient(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null

export const getAccessToken = async () => {
  if (!supabase) return null
  const { data } = await supabase.auth.getSession()
  return data.session?.access_token ?? null
}

export const getOrCreateSession = async () => {
  if (!supabase) return null

  const { data: current, error: sessionError } = await supabase.auth.getSession()
  if (sessionError) throw sessionError
  if (current.session) return current.session

  // Қолданушыға тіркелу формасын көрсетпей, жеке қауіпсіз сессия жасаймыз.
  const { data, error } = await supabase.auth.signInAnonymously()
  if (error) throw error
  return data.session
}
